import React from 'react'
import OrderSummaryItem from './../../../components/order-summary-item/order-summary-item.component'
import ConfirmedTicketsComponent from '../../../components/confirmed-tickets/confirmed-tickets.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Creators as TicketConsultCreators } from '../../../ducks/ticket-consult/ticket-consult'
import store from '../../../helpers/store'

class Tickets extends React.Component {
	componentDidMount() {
		const { match, loadTicketSale } = this.props
		const { orderid } = match.params
		loadTicketSale(orderid)
	}

	render() {
		const { ticketsGoing, ticketsReturn } = this.props
		if (ticketsGoing.length == 0) return null

		const passengers = ticketsGoing.map(
			({
				passenger,
				documentType: documenttype,
				documentNumber: documentnumber,
			}) => ({
				documenttype,
				documentnumber,
				name: passenger,
			})
		)

		const dataGoing = buildData(ticketsGoing)
		const tripSummary = Object.assign(dataGoing.tripSummary, {
			busCompany: ticketsGoing[0].enterprise,
		})

		const items = [
			<OrderSummaryItem
				key={0}
				origin={dataGoing.originCity}
				busSeats={dataGoing.busSeats}
				tripPrice={dataGoing.tripPrice}
				destination={dataGoing.destinationCity}
				tripGoingSummary={tripSummary}
			/>,
			<ConfirmedTicketsComponent
				key={1}
				{...{ passengers, ticketsGoing, ticketsReturn }}
			/>,
		]

		if (ticketsReturn.length > 0) {
			const dataReturn = buildData(ticketsReturn)
			const tripSummaryReturn = Object.assign(dataReturn.tripSummary, {
				busCompany: ticketsGoing[0].enterprise,
			})

			items.push(
				<OrderSummaryItem
					key={2}
					origin={dataReturn.originCity}
					busSeats={dataReturn.busSeats}
					tripPrice={dataReturn.tripPrice}
					destination={dataReturn.destinationCity}
					tripGoingSummary={tripSummaryReturn}
				/>,
				<ConfirmedTicketsComponent
					key={3}
					isReturn
					{...{ passengers, ticketsGoing, ticketsReturn }}
				/>
			)
		}

		return <div>{items}</div>
	}
}

const buildData = (tickets) => {
	const firstTicket = tickets[0]
	const { modality, departure, originCity, destinationCity } = firstTicket
	const tripSummary = {
		busClass: modality,
		tripDate: new Date(departure),
		departure: new Date(departure),
	}
	const tripPrice = {
		value: firstTicket.value,
		points: firstTicket.points,
	}

	const busSeats = tickets.map(({ busSeatNumber }) => ({
		number: busSeatNumber,
	}))

	return { busSeats, tripPrice, tripSummary, originCity, destinationCity }
}

const mapStateToProps = ({ ticketConsult }) => ({
	ticketsGoing: ticketConsult.ticketsGoing,
	ticketsReturn: ticketConsult.ticketsReturn,
})

const mapDispatchToProps = {
	loadTicketSale: TicketConsultCreators.load,
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Tickets))
